import { Box, FormControl, FormControlLabel, RadioGroup } from "@mui/material";
import { KwaakaRadio } from "@src/components/Radio/KwaakaRadio";
import React, { FC } from "react";
import { GraphConfig } from "../domain/model/GraphConfig";

interface SelectGraphProps {
  onGraphSelected: (graph: string) => void;
  selectedGraph: string;
  graphs: string[];
  config: GraphConfig;
}

export const SelectGraph: FC<SelectGraphProps> = (props) => {
  return (
    <Box borderBottom={1} borderColor={"#E8E8E9"}>
      <FormControl sx={{ mt: "30px", mb: "20px" }}>
        <RadioGroup
          row
          value={props.selectedGraph}
          onChange={(event) => {
            props.onGraphSelected(event.target.value);
          }}
        >
          {props.graphs.map((graph) => {
            return (
              <FormControlLabel
                key={graph}
                value={graph}
                control={<KwaakaRadio />}
                label={props.config[graph]?.name}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};